export const logoutHandler = () => {
  const domain = `${window.location.protocol}//${window.location.host}`;
  const authDomain = process.env.REACT_APP_BFF_URL || domain;
  const redirectUrl = `${authDomain}/api/v1/logout?redirectUrl=${domain}/`;
  localStorage.setItem("logoutEvent", Date.now().toString());
  window.location.replace(redirectUrl);
};
